import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import TableCell from '@mui/material/TableCell';

export const StyledTableContainer = styled(TableContainer)(() => ({
  width: '100%',
  overflowX: 'auto',
}));

export const StyledTable = styled(Table)(({ theme }) => ({
  borderCollapse: 'separate',
  borderSpacing: 0,
  width: '100%',

  '.MuiTableHead-root': {
    borderTop: 'none',
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.fixed.white
        : theme.palette.status.offline,
  },

  '.MuiTableHead-root .MuiTableCell-root': {
    fontWeight: 700,
    fontSize: 14,
    borderTop: 'none',
    borderBottom: 'none',
  },

  '.MuiTableHead-root .MuiTableRow-root:first-of-type .MuiTableCell-root:first-of-type':
    {
      borderTopLeftRadius: '8px',
    },

  '.MuiTableHead-root .MuiTableRow-root:first-of-type .MuiTableCell-root:last-of-type':
    {
      borderTopRightRadius: '8px',
    },

  '.MuiTableCell-root': {
    border: `1px solid ${theme.palette.grey['02']}`,
    borderLeft: 'none',
    borderRight: 'none',
    fontWeight: 300,
  },

  '.MuiTableBody-root .MuiTableRow-root:hover': {
    backgroundColor: theme.palette.grey['02'],
    cursor: 'pointer',
  },

  '.MuiTableBody-root .MuiTableRow-root': {
    transition: 'background-color 0.2s ease',
    maxHeight: 38,
  },
}));

export const StyledTableRow = styled(TableRow)(() => ({
  transition: 'background-color 0.2s ease',
  maxHeight: 38,
}));

export const StyledTablePagination = styled(TablePagination)(({ theme }) => ({
  color: theme.palette.white['06'],
  marginTop: theme.spacing(1),

  '.MuiTablePagination-actions': {
    color: theme.palette.white['06'],
  },

  '.MuiTablePagination-displayedRows': {
    color: theme.palette.white['06'],
  },
}));

export const StyledTableCell = styled(TableCell)(({ col }) => ({
  width: col.width,
  minWidth: col.minWidth,
  maxWidth: col.maxWidth,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));
